import request from "@/utils/request";

export function getPage(condition, pagination) {
  return request({
    url: "/crm/bid/page",
    method: "post",
    data: { condition: condition, pagination: pagination },
  });
}
export function saveOrUpdate(data) {
  return request({
    url: "/crm/bid/saveOrUpdate",
    method: "post",
    data,
  });
}

export function get(id) {
  return request({
    url: "/crm/bid/get",
    method: "get",
    params: { id },
  });
}

export function deleteById(id) {
  return request({
    url: "/crm/bid/deleteById",
    method: "post",
    data: { id: id },
  });
}

export function exportExcel(condition, pagination) {
  return request({
    url: "/crm/bid/exportExcel",
    method: "post",
    data: { condition: condition, pagination: pagination },
    responseType: "blob",
  });
}

export function submit(id) {
  return request({
    url: "/crm/bid/submit",
    method: "post",
    data: { id: id },
  });
}
// 下载模版
// export function downloadTemplate() {
//   return request({
//     url: '/customer/customerApply/downloadTemplate',
//     method: 'post',
//     responseType: 'blob'
//   })
// }
// 导入
export function uploadFile(formData) {
  return request({
    url: "/crm/bid/excelImport",
    method: "post",
    data: formData,
  });
}
// 作废
export function cancellation(id) {
  return request({
    url: "/crm/bid/cancellation",
    method: "post",
    data: { id: id },
  });
}
// 获取客户列表
export function getCustomerApplyModels(condition, pagination) {
  return request({
    url: "/crm/bid/module/custimer/getCustomerApplyModels",
    method: "post",
    data: { condition: condition, pagination: pagination },
  });
}
// 获取已选客户列表
export function getCustomerBidPage(condition, pagination) {
  return request({
    url: "/crm/bid/module/custimer/page",
    method: "post",
    data: { condition: condition, pagination: pagination },
  });
}
// 删除已选客户
export function deleteByCustomerBidId(id) {
  return request({
    url: "/crm/bid/module/custimer/deleteById",
    method: "post",
    data:{id},
  });
}
// 推送所有用户
export function publishesAll(data) {
  return request({
    url: "/crm/bid/module/custimer/publishesAll",
    method: "post",
    data,
  });
}
// 发布选择用户
export function publishes(data) {
  return request({
    url: "/crm/bid/module/custimer/publishes",
    method: "post",
    data,
  });
}
// 发布投标
export function publishBid (data) {
  return request({
    url: "/crm/bid/module/custimer/publishBid",
    method: "post",
    data,
  });
}
// 查询添加公式弹窗
export function templateFormulaGet(data) {
  return request({
    url: "/crm/bid/template/get",
    method: "get", 
    params: data ,
  });
}
// 保存公式弹窗
export function templateFormulaSaveOrUpdate(data) {
  return request({
    url: "/crm/bid/template/saveOrUpdate",
    method: "post",
    data,
  });
}
// 外部参考物料名称
export function selectWastePage(data) {
  return request({
    url: "/crm/bid/selectWastePage",
    method: "post",
    data,
  });
}
// 查看开标
export function getBigModuleOrderLine(data) {
  return request({
    url: "/crm/bid/getBigModuleOrderLine",
    method: "get", 
    params: data ,
  });
}
// 查看历史开标报表
export function selectHistoryWinTheBidPage(condition,pagination) {
  return request({
    url: "/crm/bid/selectHistoryWinTheBidPage",
    method: "post",
    data: { condition,pagination},
  });
}






